import baseHasIn from "./component-library332.mjs";
import hasPath from "./component-library333.mjs";
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}
export {
  hasIn as default
};
